import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertiesPanelComponent } from "@wms/properties-panel";
import { DatasetAwareFormComponent } from "../dataset-aware-form.component";
import { CommonWidgetDirective } from "@wms/directives";

@Component({
  selector: 'wm-checkboxset',
  standalone: true,
  imports: [CommonModule, CommonWidgetDirective],
  templateUrl: './checkboxset.component.html',
  styleUrls: ['./checkboxset.component.less'],
  inputs: ['dataset', 'datafield', 'displayfield', 'datavalue'],
  outputs: ['onChange']
})
export class CheckboxsetComponent extends DatasetAwareFormComponent {
  propPanel!: PropertiesPanelComponent;

  constructor() {
    super();
    this.propPanel = inject(PropertiesPanelComponent);
  }

  onCheckboxLabelClick($event: any, key: any) {
    if (!$($event.target).is('input')) {
      return;
    }
    // construct the _model from the checked elements.
    const inputElements = this.nativeElement.querySelectorAll('input:checked');
    const keys: any = [];
    inputElements.forEach((el: any) => {
      keys.push(el.value);
    })
    this.modelByKey = keys;
  };
}
